import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { ContactB2B } from '@shared/services/contact-b2b/models';

@Injectable({ providedIn: 'root' })
export class ContactB2bService extends ApiServiceBase<ContactB2B> {
  constructor() {
    super('contact/b2b', 'contactB2B', 'fournierWebservice');
  }
}
